import React from "react";

import truckimage from '../../assets/images/SecNav3360x630.jpg';
import './imagecontent.css';

function replaceAll(string, search, replace) {
    return string.split(search).join(replace);
  }

const Imagecontent = (Props) => {

    let title = replaceAll(Props.title, ".", "/");
    return <div className="secnav__imgcon">
     <img className="secnav__imgcon__img" src={truckimage}/>
     {/* <h3>{title}</h3> */}
    </div>
};

export default Imagecontent;